(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[384],{

/***/ 73669:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutors/search",
      function () {
        return __webpack_require__(71110);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TutorSearchResultsList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__(51436);
;// CONCATENATED MODULE: ./components/TutorProfileSubjectList.js


function TutorProfileSubjectList(param) {
    let { tutorProfile , subjects  } = param;
    const subjectsCount = subjects.length;
    const truncateLimit = 6;
    const truncatedSubjects = (()=>{
        return subjects.slice(0, truncateLimit);
    })();
    const isTruncated = subjectsCount > truncateLimit;
    const excludedSubjectsCount = subjectsCount - truncateLimit;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "d-flex flex-wrap",
        children: [
            truncatedSubjects.map((subject)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "me-2 mb-2 p-2 bg-light rounded",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "small",
                        children: subject.name
                    })
                }, subject.id)),
            isTruncated && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "mb-2 p-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "small",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        href: "/tutors/".concat(tutorProfile.slug),
                        passHref: true,
                        children: [
                            "+",
                            excludedSubjectsCount,
                            "more"
                        ]
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/TutorProfileRate.js

function TutorProfileRate(param) {
    let { subject , level , subjectLevels , modality  } = param;
    const subjectAndLevelPresent = !!((subject === null || subject === void 0 ? void 0 : subject.slug) && (level === null || level === void 0 ? void 0 : level.slug));
    const subjectLevel = (()=>{
        return subjectLevels.find((subjectLevel)=>{
            const otherSubject = subjectLevel.subject;
            const otherLevel = subjectLevel.level;
            if (subject && level) {
                return otherSubject.id === subject.id && otherLevel.id === level.id;
            } else if (subject) {
                return otherSubject.id === subject.id;
            } else if (level) {
                return otherLevel.id === level.id;
            }
        });
    })();
    const rateAttr = modality === "inPerson" ? "inPersonRate" : "onlineRate";
    const formattedRateAttr = rateAttr === "inPersonRate" ? "formattedInPersonRate" : "formattedOnlineRate";
    const lowestRate = (()=>{
        const filteredSubjectLevels = subjectLevels.filter((subjectLevel)=>!!subjectLevel[rateAttr]);
        const sorted = filteredSubjectLevels.sort((a, b)=>a[rateAttr] - b[rateAttr]);
        return sorted && sorted[0] && sorted[0][formattedRateAttr];
    })();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        children: subjectAndLevelPresent ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: subjectLevel[formattedRateAttr]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                    children: "from "
                }),
                lowestRate
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/tutorProfile/Rating.js
var Rating = __webpack_require__(79963);
// EXTERNAL MODULE: ./components/TutorSearchResultsRow.module.scss
var TutorSearchResultsRow_module = __webpack_require__(55512);
var TutorSearchResultsRow_module_default = /*#__PURE__*/__webpack_require__.n(TutorSearchResultsRow_module);
;// CONCATENATED MODULE: ./components/TutorSearchResultsRow.js












function TutorSearchResultsRow(param) {
    let { tutorProfile , subject , level  } = param;
    const hasTaughtTenHours = (()=>{
        return tutorProfile.totalLessonMinutes > 600;
    })();
    const lessonHoursLabel = (()=>{
        const lessonHours = tutorProfile.totalLessonHours;
        if (!lessonHours) return;
        const roundedLessonHours = Math.ceil(lessonHours / 5) * 5;
        return "".concat(roundedLessonHours, "+");
    })();
    const showRating = tutorProfile.tutorReviewsCount > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            md: 3,
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: tutorProfile.profilePicture.thumb.url,
                                className: "rounded",
                                width: 150,
                                height: 150,
                                alt: "Profile picture",
                                style: {
                                    maxWidth: "100%",
                                    height: "auto"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            xs: 12,
                            md: 6,
                            className: "mb-2 mb-md-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "d-block d-md-flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-md-flex mb-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Title */.Z.Title, {
                                            className: "my-auto me-md-2 mb-2 mb-md-0 d-flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/tutors/".concat(tutorProfile.slug),
                                                    passHref: true,
                                                    children: tutorProfile.firstNameAndLastInitial
                                                }),
                                                showRating && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((TutorSearchResultsRow_module_default()).ratingContainer, " ms-2"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                                        tutorProfile: tutorProfile,
                                                        showCount: false,
                                                        size: 20
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Text */.Z.Text, {
                                    children: tutorProfile.tagLine
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorProfileSubjectList, {
                                    tutorProfile: tutorProfile,
                                    subjects: tutorProfile.subjects
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            md: 3,
                            className: "d-md-flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex flex-column mx-auto w-100",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_solid_svg_icons_index_es/* faPoundSign */.x_I,
                                                size: "lg",
                                                fixedWidth: true,
                                                className: "me-1 my-auto text-success"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                className: "d-inline fs-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorProfileRate, {
                                                    subject: subject,
                                                    level: level,
                                                    subjectLevels: tutorProfile.subjectLevels,
                                                    modality: "online"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-3 mb-3",
                                        children: [
                                            tutorProfile.averageRequestResponseTimeLabel && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons_index_es/* faPaperPlane */.XCy,
                                                        size: "lg",
                                                        fixedWidth: true,
                                                        className: "me-1 text-success"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            "Responds in ",
                                                            tutorProfile.averageRequestResponseTimeLabel
                                                        ]
                                                    })
                                                ]
                                            }),
                                            hasTaughtTenHours && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons_index_es/* faStopwatch */.U$5,
                                                        size: "lg",
                                                        fixedWidth: true,
                                                        className: "me-1 text-success"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            lessonHoursLabel,
                                                            " hours taught"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-auto",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                href: "/tutors/".concat(tutorProfile.slug),
                                                passHref: true,
                                                className: "mb-md-2 btn btn-outline-secondary d-block",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons_index_es/* faUser */.ILF,
                                                        className: "me-1"
                                                    }),
                                                    "View Profile"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                href: "/tutors/".concat(tutorProfile.slug, "/send-message"),
                                                passHref: true,
                                                className: "mb-md-2 btn btn-primary d-block",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons_index_es/* faComments */.lXL,
                                                        className: "me-1"
                                                    }),
                                                    "Send Message"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./public/images/computer-search.jpg
/* harmony default export */ var computer_search = ({"src":"/_next/static/media/computer-search.65fac5a8.jpg","height":428,"width":640,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAcEAABBQEBAQAAAAAAAAAAAAABAAIDBRFBFCP/xAAUAQEAAAAAAAAAAAAAAAAAAAAD/8QAGBEAAgMAAAAAAAAAAAAAAAAAAAECMUH/2gAMAwEAAhEDEQA/AJreya6e/i8zfjMTpdunDziIiGNsTEf/2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./components/tutorSearch/Banner.js





function TutorSearchBanner() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "d-md-flex rounded border bg-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-grow-1 p-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mb-2 text-primary",
                        children: "Need a hand with your search?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        className: "mb-3 text-muted",
                        children: "We can help you find the perfect tutor. Give us a call!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "phone-cta",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons_index_es/* faPhone */.j1w,
                                size: "lg",
                                className: "me-2 text-info"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "tel:+441509265623",
                                className: "text-primary",
                                children: "01509 265 623"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: computer_search,
                width: 350,
                height: "100%",
                alt: "We can help with your search",
                className: "rounded-right",
                style: {
                    maxWidth: "100%",
                    height: "auto",
                    objectFit: "cover",
                    objectPosition: "center"
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/TutorSearchResultsList.js



function TutorSearchResultsList(param) {
    let { results , subject , level  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: results.map((tutorProfile, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorSearchResultsRow, {
                            tutorProfile: tutorProfile,
                            subject: subject,
                            level: level
                        })
                    }, tutorProfile.id),
                    (index === 2 || index === results.length - 1) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorSearchBanner, {})
                    })
                ]
            }))
    });
}


/***/ }),

/***/ 79963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TutorProfileRating; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_simple_star_rating__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13773);


function TutorProfileRating(param) {
    let { tutorProfile , showCount =true , size =25  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_simple_star_rating__WEBPACK_IMPORTED_MODULE_1__/* .Rating */ .i, {
                initialValue: tutorProfile.averageClientRating,
                readonly: true,
                allowHalfIcon: true,
                size: size
            }),
            showCount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("em", {
                className: "small",
                children: [
                    "(",
                    tutorProfile.tutorReviewsCount,
                    " reviews)"
                ]
            })
        ]
    });
}


/***/ }),

/***/ 71110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TutorsSearch; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./components/HeroSearch.js + 3 modules
var HeroSearch = __webpack_require__(56665);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./utils/jsonApiClient.js + 1 modules
var jsonApiClient = __webpack_require__(42882);
// EXTERNAL MODULE: ./components/TutorSearchResultsList.js + 5 modules
var TutorSearchResultsList = __webpack_require__(38132);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-regular-svg-icons/index.es.js
var free_regular_svg_icons_index_es = __webpack_require__(56024);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ButtonGroup.js
var ButtonGroup = __webpack_require__(2086);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var react_loading_skeleton_dist = __webpack_require__(84849);
// EXTERNAL MODULE: ./components/tutorRequest/RequestContainer.js + 5 modules
var RequestContainer = __webpack_require__(6006);
;// CONCATENATED MODULE: ./components/tutorSearch/Container.js















function TutorSearchContainer(param) {
    let { subject , level , lat , lon , modality , page =1 , onPaginate  } = param;
    const router = (0,next_router.useRouter)();
    const search = {};
    if (subject) search.subject = subject;
    if (level) search.level = level;
    if (lat && lon) {
        search.lat = lat;
        search.lon = lon;
    }
    if (modality) search.modality = modality;
    const fetcher = (param)=>{
        let { params  } = param;
        const jsonApi = (0,jsonApiClient/* default */.Z)();
        return jsonApi.findAll("tutor-profile", params);
    };
    const { data , error  } = (0,dist/* default */.ZP)({
        url: "/tutor-profiles",
        params: {
            filter: {
                query: search,
                employee_review_status: "approved",
                only_available: true
            },
            include: "subject-levels,subject-levels.subject,subject-levels.level,subjects,levels",
            page: {
                size: 25,
                number: page
            }
        }
    }, fetcher);
    if (error) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: "mb-5 pt-3",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "text-danger text-center mb-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_regular_svg_icons_index_es/* faTimesCircle */.nYk,
                        size: "lg"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: "Error fetching tutor profiles."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "link",
                        onClick: ()=>router.reload(),
                        children: "Try again"
                    })
                })
            ]
        })
    });
    if (!data) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        className: "mb-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_loading_skeleton_dist/* default */.Z, {
                height: 50,
                className: "mb-3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    md: 3,
                                    className: "text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_loading_skeleton_dist/* default */.Z, {
                                        borderRadius: 5,
                                        height: 150,
                                        width: 150
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    md: 6,
                                    className: "mb-2 mb-md-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_loading_skeleton_dist/* default */.Z, {
                                        count: 5
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    xs: 12,
                                    md: 3,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_loading_skeleton_dist/* default */.Z, {
                                            count: 3
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_loading_skeleton_dist/* default */.Z, {
                                            count: 2,
                                            height: 40
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
    const pageCount = data.meta["page-count"];
    const recordCount = data.meta["record-count"];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        className: "mb-5",
        children: [
            recordCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: "mb-3",
                        children: [
                            recordCount,
                            " Tutors Are Available"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorSearchResultsList/* default */.Z, {
                            results: data.data,
                            subject: subject,
                            level: level
                        })
                    })
                ]
            }),
            pageCount > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-center mb-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonGroup/* default */.Z, {
                        className: "mb-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                size: "sm",
                                variant: "outline-primary",
                                disabled: page === 1,
                                onClick: ()=>onPaginate("back"),
                                children: "Back"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                size: "sm",
                                variant: "outline-primary",
                                disabled: page === pageCount,
                                onClick: ()=>onPaginate("next"),
                                children: "Next"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "small",
                        children: [
                            "Page ",
                            page,
                            " of ",
                            pageCount
                        ]
                    })
                ]
            }),
            recordCount === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                    xs: 12,
                    md: 8,
                    className: "mx-md-auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "mb-3",
                            children: "We Couldn't Find a Matching Tutor"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-muted mb-4",
                            children: "Enter your details below and we'll get to work to find you a great tutor!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestContainer/* default */.Z, {
                                    subject: subject,
                                    level: level,
                                    modality: modality
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./pages/tutors/search.js








function TutorsSearch() {
    const router = (0,next_router.useRouter)();
    const query = router.query;
    const { subject , level , lat , lon , address , modality  } = query;
    const page = parseInt(query.page || 1);
    const movePage = (direction)=>{
        router.push({
            query: {
                ...query,
                page: direction === "next" ? page + 1 : page - 1
            }
        });
    };
    const location = {
        lat,
        lon,
        formattedAddress: address
    };
    const fetcher = (param)=>{
        let { resource , params  } = param;
        const jsonApi = (0,jsonApiClient/* default */.Z)();
        return jsonApi.findAll(resource, params);
    };
    const [subjectRecord, setSubjectRecord] = (0,react.useState)({});
    const [levelRecord, setLevelRecord] = (0,react.useState)({});
    (0,react.useEffect)(()=>{
        if (!subject) return;
        const fetchData = async ()=>{
            const { data  } = await fetcher({
                resource: "subject",
                params: {
                    filter: {
                        slug: subject
                    }
                }
            });
            setSubjectRecord(data[0]);
        };
        fetchData();
    }, [
        subject
    ]);
    (0,react.useEffect)(()=>{
        if (!level) return;
        const fetchData = async ()=>{
            const { data  } = await fetcher({
                resource: "level",
                params: {
                    filter: {
                        slug: level
                    }
                }
            });
            setLevelRecord(data[0]);
        };
        fetchData();
    }, [
        level
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Search for qualified tutors"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-light bg-gradient py-4 mb-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSearch/* default */.Z, {
                        compact: true,
                        location: location,
                        modality: modality,
                        subject: subjectRecord,
                        level: levelRecord
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorSearchContainer, {
                subject: subject,
                level: level,
                lat: lat,
                lon: lon,
                modality: modality,
                page: page,
                onPaginate: movePage
            })
        ]
    });
}


/***/ }),

/***/ 55512:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ratingContainer":"TutorSearchResultsRow_ratingContainer__d3C9j"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [766,734,687,105,665,6,774,888,179], function() { return __webpack_exec__(73669); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);